import { isEqual } from "lodash";
import { useState } from "react";
import {
  Description,
  InventoryPrice,
  Review,
} from "@/components/Pages/ProductDetailPage";
import { IFeature, IProductVariant } from "@/interfaces/product";
import { IReview } from "@/interfaces/review";
import generateIds from "@/utils/generate";

interface ProductTabProps {
  longDescription: string;
  features: IFeature[];
  variants: IProductVariant[];
  name: string;
  id: number;
  reviews: IReview[];
}

const ProductTab: React.FC<ProductTabProps> = (props) => {
  const { features, variants, longDescription, name, id, reviews } = props;
  const [tab, setTab] = useState<number>(0);
  const tabIds = generateIds(3);

  const tabsList = [
    {
      id: tabIds[0],
      label: "Description",
    },
    {
      id: tabIds[1],
      label: "Inventory & price",
    },
    {
      id: tabIds[2],
      label: `Review (${reviews.length})`,
    },
  ];

  const contentRender = (tab: number) => {
    switch (tab) {
      case 0:
        return (
          <Description features={features} longDescription={longDescription} />
        );
      case 1:
        return <InventoryPrice variants={variants} />;
      case 2:
        return <Review name={name} id={id} reviews={reviews} />;
      default:
        return;
    }
  };

  return (
    <section className="w-full flex flex-col">
      <div className="w-full flex border-b">
        {tabsList.map(({ id, label }, index) => (
          <button
            className={`flex-1 py-4 text-lg border-b-2 select-none ${
              isEqual(index, tab) ? "border-icon" : "border-transparent"
            } transition-all duration-500`}
            key={id}
            onClick={() => setTab(index)}
          >
            {label}
          </button>
        ))}
      </div>
      <div className="py-12 min-h-96">{contentRender(tab)}</div>
    </section>
  );
};

export default ProductTab;
